/* eslint-disable */
import React from "react";

function Header() {
  return (
    <header className="header">
      <h1>Travel Recommendation App</h1>
    </header>
  );
}
export default Header;
